/* Feedback for native Shopify contact forms. Shopify still owns CAPTCHA and
 * the POST; this script never sends a request or claims delivery before the
 * returned page contains Shopify's success state. */
(() => {
  const STALLED_MS = 10000;

  function init(root) {
    const forms = root.matches?.('form[data-contact-submit-state]') ? [root] :
      root.querySelectorAll('form[data-contact-submit-state]');
    forms.forEach((form) => {
      if (form.dataset.contactStateReady) return;
      form.dataset.contactStateReady = 'true';

      const button = form.querySelector('[type="submit"]');
      const validation = form.querySelector('[data-contact-validation]');
      const status = form.querySelector('[data-contact-status]');
      if (!button || !validation || !status) return;

      const label = button.textContent.trim();
      let busy = false;
      let stallTimer;

      function reset() {
        clearTimeout(stallTimer);
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        status.textContent = '';
      }

      // Invalid controls never dispatch submit. Keep the browser's own field
      // validation and focus behavior, while making every bad field visible.
      form.addEventListener('invalid', (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        event.target.setAttribute('aria-invalid', 'true');
        validation.textContent = form.dataset.validationError;
        validation.hidden = false;
      }, true);

      const updateValidation = (event) => {
        if (event.target instanceof HTMLElement && event.target.validity?.valid) {
          event.target.removeAttribute('aria-invalid');
        }
        if (!form.querySelector(':invalid')) validation.hidden = true;
      };
      form.addEventListener('input', updateValidation);
      form.addEventListener('change', updateValidation);

      // Capture runs before Shopify's form-level CAPTCHA submit listener.
      // Never prevent the first valid submit; only suppress a second attempt
      // while the first CAPTCHA/POST may still be in flight.
      form.addEventListener('submit', (event) => {
        if (busy) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        busy = true;
        validation.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = form.dataset.sendingLabel;
        status.textContent = form.dataset.sendingLabel;
        stallTimer = setTimeout(() => {
          reset();
          status.textContent = form.dataset.stalledNote;
        }, STALLED_MS);
      }, true);

      // A challenge can return through the back/forward cache without another
      // page render; at that point the old form must be usable again.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) reset();
      });

      const result = form.querySelector('[data-contact-success], [data-contact-errors]');
      if (result) {
        const url = new URL(location.href);
        for (const name of [...url.searchParams.keys()]) {
          if (name === 'contact_posted' || name === 'form_type' || name.startsWith('contact[')) {
            url.searchParams.delete(name);
          }
        }
        history.replaceState(history.state, '', url);
        result.focus({preventScroll:true});
        result.scrollIntoView({block:'center'});
      }
    });
  }

  if (!window.AsansaraContactSubmitState) {
    window.AsansaraContactSubmitState = init;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
  window.AsansaraContactSubmitState(document);
})();
